// packages/apps/workoutsmart/src/components/calendars/WorkoutSessionReferenceViewer.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Stack, Chip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { DomainObjectModal } from '@platform/core/src/components/domain';
import { workoutSessionConfig } from '../../config/domainConfig';

const WorkoutSessionReferenceViewer = ({ resource, onActionSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!resource) {
    return <Typography variant="body2" color="text.secondary">Loading session...</Typography>;
  }

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const handleModalActionSuccess = (action, item) => {
    if (action === 'delete') {
      handleClose();
      if (onActionSuccess) {
        onActionSuccess(action, item);
      }
    }
  };

  return (
    <>
      <Paper
        variant="outlined"
        onClick={handleOpen}
        sx={{
          p: 1.5,
          cursor: 'pointer',
          '&:hover': {
            borderColor: 'primary.main',
            boxShadow: 1,
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <HistoryIcon color="primary" />
          <Stack sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Typography variant="body1" fontWeight="medium" noWrap>
              {resource.name || 'Workout Session'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Click to view details
            </Typography>
          </Stack>
          {resource.status && (
            <Chip label={resource.status.replace('_', ' ')} size="small" />
          )}
        </Stack>
      </Paper>

      {isModalOpen && (
        <DomainObjectModal
          open={isModalOpen}
          onClose={handleClose}
          itemToEdit={resource}
          config={workoutSessionConfig}
          sectionTitle="Workout Session Details"
          onActionSuccess={handleModalActionSuccess}
        />
      )}
    </>
  );
};

WorkoutSessionReferenceViewer.propTypes = {
  resource: PropTypes.object,
  onActionSuccess: PropTypes.func,
};

export default WorkoutSessionReferenceViewer;